var _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconOvoCoin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_12",
    "data-name": "Component 19 \\u2013 12",
    width: 37.436,
    height: 38.548,
    viewBox: "0 0 37.436 38.548",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 18.718,
    cy: 18.973,
    rx: 18.718,
    ry: 18.973,
    transform: "translate(0 0.098)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(0.75)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M-2019.782,702.506a18.738,18.738,0,0,0,17.283,11.835,18.83,18.83,0,0,0,18.044-14.093c-1.927,4.612-5.549,9.292-11.038,8.033a27.243,27.243,0,0,0-7.2-1c-3.789,0-5.574,1-8.715,1C-2014.7,708.281-2017.406,707.057-2019.782,702.506Z",
    transform: "translate(2020.553 -675.794)",
    fill: "#d6225e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M-2004.641,39.158A18.893,18.893,0,0,0-2023.076,23.3a18.831,18.831,0,0,0-18.055,14.13c1.99-4.383,5.523-8.567,10.748-7.368a27.246,27.246,0,0,0,7.2,1c3.789,0,5.574-1,8.715-1C-2010.487,30.065-2007.358,31.855-2004.641,39.158Z",
    transform: "translate(2041.13 -23.303)",
    fill: "#f49334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M-1878.623,311.847h-4.33a9.319,9.319,0,0,0-8.834-6.648,9.319,9.319,0,0,0-8.834,6.648h-4.154v2.23h3.741q-.022.328-.023.662c0,.187.006.373.016.558h-3.734v2.23h4.122a9.323,9.323,0,0,0,8.865,6.752,9.323,9.323,0,0,0,8.866-6.752h4.3V315.3h-3.911c.01-.185.016-.37.016-.558,0-.222-.008-.443-.023-.662h3.917Zm-13.164,8a5.046,5.046,0,0,1-4.966-5.11,5.046,5.046,0,0,1,4.966-5.11,5.046,5.046,0,0,1,4.966,5.11A5.046,5.046,0,0,1-1891.787,319.849Z",
    transform: "translate(1909.7 -295.016)",
    fill: "#1d266b"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOvoCoin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-ovo-coin.20129763.svg";
export { ForwardRef as ReactComponent };